import { render, staticRenderFns } from "./BlockIntroduction.vue?vue&type=template&id=caf3322e&scoped=true"
import script from "./BlockIntroduction.vue?vue&type=script&lang=js"
export * from "./BlockIntroduction.vue?vue&type=script&lang=js"
import style0 from "./BlockIntroduction.vue?vue&type=style&index=0&id=caf3322e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf3322e",
  null
  
)

export default component.exports